export type MobileOS = 'android' | 'ios' | 'other';

/**
 * Detect the mobile operating system from the user agent.
 * iPadOS recent versions report themselves as "Macintosh", so they are
 * disambiguated through the touch points count.
 */
const getMobileOS = (): MobileOS => {
  const ua = navigator.userAgent || '';

  if (
    /iPad|iPhone|iPod/.test(ua) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
  ) {
    return 'ios';
  }

  if (/Android/.test(ua)) {
    return 'android';
  }

  return 'other';
};

export default getMobileOS;
